import { api } from './api';

export async function shareLocation({ mobile_number, case_id, lat, long }) {
  return api.post('/api/cases/update-location', {
    mobile_number,
    case_id,
    lat,
    long,
  });
} 